<script lang="ts" setup>
defineProps<{
  text: string;
  title: string;
  icon: string;
}>();
</script>

<template>
  <div>
    <div class="mb-3 flex space-x-6 md:mb-4">
      <div class="h-6 w-6 md:h-8 md:w-8"><img class="h-full w-full" :src="icon" :alt="title" /></div>
      <div class="text-text-white flex items-center text-[19px] leading-[120%] font-semibold tracking-normal md:text-[20px]">
        {{ title }}
      </div>
    </div>
    <div class="text-text-white text-[18px] leading-[120%] tracking-normal md:text-[20px]">{{ text }}</div>
  </div>
</template>
